import React from 'react';
import { FormattedMessage } from 'react-intl';
import InsightsIcon from '@mui/icons-material/Insights';
import { routePathMap } from '../common/routes/routePaths';
import TIRouteProps from '../common/routes/TIRouteProps';
import InsightPageFC from './InsightPage';

export const InsightsPageRoute: TIRouteProps = {
  path: routePathMap.insights,
  component: InsightPageFC,
  exact: false,
  title: <FormattedMessage id="tabs.insights" />,
  icon: <InsightsIcon />
};
